import StepperArrow from "@/pages/companyDashboard/StepperArrow";
import {memo, type FC} from "react";

const StepperArrows: FC<{
  data: unknown[];
  onNext(): void;
  onPrevious(): void;
  showedIndex: number;
  isLoading: boolean;
  offset?: number;
}> = ({data, onNext, onPrevious, isLoading, showedIndex, offset = 0}) => {
  if (data.length <= 1) {
    return null;
  }

  return (
    <>
      <StepperArrow
        direction="LEFT"
        containerClassName="absolute -left-4 lg:-left-12 z-50 top-1/2 -translate-y-1/2"
        isDisabled={showedIndex <= 1}
        onClick={onPrevious}
      />
      <StepperArrow
        onClick={onNext}
        isLoading={isLoading}
        direction="RIGHT"
        containerClassName="absolute -right-4 lg:-right-12 z-50 top-1/2 -translate-y-1/2"
        isDisabled={showedIndex + offset > data.length - 1}
      />
    </>
  );
};

export default memo(StepperArrows);
